<template>
<div class="product-preview" v-if="product">
    <div class="columns">
        <div class="column is-half product-preview__photo">
            <a v-if="photo" class="product-preview__photo__previewer is-block" :href="photo.url" :data-lightbox="product.title">
                <img class="is-block" :src="photo.url" />
            </a>
            <div v-if="thumbs" class="product-preview__photo__thumbs">
                <agile v-if="thumbs && thumbs.length > 1" :options="aglie_opt">
                    <div class="slide slide__thumbnail" v-for="thumb, i in thumbs">
                        <a class="is-block" href="#" @click.prevent="pick_thumb(i)">
                            <img class="is-block" :src="thumb.url" />
                        </a>
                    </div>
                </agile>
            </div>
        </div>
        <div class="column is-half product-preview__content">
            <h1 v-if="is_own_page" class="title is-5">{{product.title}}</h1>
            <h2 v-else class="title is-5">{{product.title}}</h2>
            <p v-if="price" class="prices title is-4">
                <span>{{price.toDollar()}}</span> <span v-if="product.discount_rate" class="button is-primary">{{product.discount_rate}}%</span> <strike v-if="price_was">{{price_was.toDollar()}}</strike>
            </p>
            <div class="content" v-html="product.short_desc"></div>
            <form class="product-preview__cart-form" method="post" @submit.prevent="add_to_cart">
                <div class="field product-preview__cart-form__params">
                    <div class="columns is-mobile">
                        <div class="column is-narrow">
                            <strong>Quantity</strong>
                        </div>
                        <div :class="'column is-' + (is_own_page ? 3 : 2)">
                            <div class="control">
                                <input @keydown="check_keydown" type="text" pattern="\d*" :class="['input', {'is-medium': is_own_page}]" v-model="qty" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field product-preview__cart-form__actions">
                    <button type="submit" :class="['button is-primary', {'is-loading' : is_loading}, {'is-medium': true}]">
                        <i class="fas fa-shopping-cart"></i> Add to Cart
                    </button>
                </div>
                <template v-if="priceInCents">
                    <iframe style="max-width:300px; width: 100%; height: 125px" loading="lazy" :src="`https://www.silverchef.finance/en_NZ/embed/weekly-rent-widget/${priceInCents}/`"></iframe>
                    <p><a href="https://www.silverchef.co.nz/pages/apply/?affiliate=0016F000020MdDP&dealer=Capital%20Hospitality%20and%20Construction" target="_blank" class="button is-text is-medium">Apply for finance</a></p>
                </template>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import { VueAgile } from 'vue-agile';
export default {
    name        :   'ProductPreview',
    props       :   ['mini_data', 'is_own_page'],
    components  :   {
        agile       :   VueAgile
    },
    data()
    {
        return {
            is_loading  :   false,
            qty         :   1,
            regx        :   /^[0-9]+$/,
            cur_index   :   0,
            aglie_opt   : {
                dots: false,
                navButtons: true,
                slidesToShow: 3
            }
        };
    },
    computed    :   {
        product()
        {
            if (this.mini_data) return this.mini_data;
            return this.$store.state.site_data;
        },
        price()
        {
            if (this.product) {
                return this.product.special_price ? this.product.special_price : this.product.price;
            }

            return null;
        },
        priceInCents () {
            if (this.price) {
                return Math.round(this.price * 100)
            }

            return null
        },
        price_was()
        {
            if (this.product && this.product.special_price) {
                return this.product.price;
            }

            return null;
        },
        thumbs()
        {
            if (this.product && this.product.images && this.product.images.length) {
                return this.product.images.map( o => o.thumb );
            }

            return null;
        },
        photo()
        {
            if (!this.thumbs || !this.thumbs.length) return null;

            return this.thumbs[this.cur_index];
        }
    },
    methods     :   {
        pick_thumb(i)
        {
            this.cur_index  =   i;
        },
        check_keydown(e) {
            if (!this.regx.test(e.key) &&
                e.key != 'Backspace' &&
                e.key != 'ArrowUp' &&
                e.key != 'ArrowDown' &&
                e.key != 'ArrowLeft' &&
                e.key != 'ArrowRight' &&
                e.key != 'Enter'
            ) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            } else if (e.key == 'Enter') {
                this.add_to_cart();
            } else if (e.key == 'ArrowUp') {
                this.qty++;
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            } else if (e.key == 'ArrowDown') {
                if (this.qty > 1) {
                    this.qty--;
                }
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }
        },
        add_to_cart()
        {
            if (this.is_loading) return false;
            this.is_loading =   true;

            let me      =   this,
                data    =   new FormData();

            data.append('csrf', this.is_own_page ? this.product.session.csrf : this.product.csrf);
            data.append('id', this.product.id);
            data.append('qty', this.qty);
            axios.post(
                base_url + endpoints.cart + 'add',
                data
            ).then(this.done_adding).catch(this.add_cart_error_handling);
        },
        done_adding(resp)
        {
            this.is_loading =   false;
            this.$bus.$emit('onCartUpdate', resp.data);
            this.$bus.$emit('onCartConfirm', resp.data);
        },
        add_cart_error_handling(error)
        {
            this.is_loading =   false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/ProductPreview.vue